module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Ramy-Youssef.f6b2ad3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Ramy-Youssef.jpg
// module id = UPa3
// module chunks = 0